<template>
    <div class="page-container">
        <el-row>
            <!--服务预约-->
            <el-form :inline="true" :model="filters" class="demo-form-inline toolbar" style="padding-bottom:0px;">
                <el-form-item label="手机号">
                    <el-input v-model.trim="filters.user" auto-complete="off" placeholder="请输入预约手机号"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="filters.status" style="width: 120px" clearable>
                        <el-option value="0" label="预约中"></el-option>
                        <el-option value="1" label="已完成"></el-option>
                        <el-option value="２" label="已取消"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="search" plain>查询</el-button>
                </el-form-item>
            </el-form>
        </el-row>
        <el-table style="width: 100%" :data="serviceList" :header-cell-style="{
                'text-align': 'center',
                'font-size': '16px',
                'font-weight': '600',
                color: '#2d2d2d',
                'background-color': '#d4f5fa',
            }" :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :row-style="tableRowStyle">
            <el-table-column prop="user" label="预约人" min-width="80"></el-table-column>
            <el-table-column prop="name" label="服务对象" min-width="70"></el-table-column>
            <el-table-column prop="mobile" label="联系方式" min-width="70"></el-table-column>
            <el-table-column prop="community" label="社区名称" min-width="80"></el-table-column>
            <el-table-column prop="address" label="服务地址" min-width="120"></el-table-column>
            <el-table-column prop="time" label="预约时间" min-width="80"></el-table-column>
            <el-table-column prop="createdTime" label="下单时间" min-width="80"></el-table-column>
            <el-table-column prop="evaluate" label="评价" min-width="60"></el-table-column>
            <el-table-column label="服务内容" min-width="100">
                <template slot-scope="scope">
                    <el-image style="width: 80px; height: 80px" :src="scope.row.pic" :preview-src-list="scope.row.picList">
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column prop="statusStr" label="状态" min-width="60"></el-table-column>
            <el-table-column label="操作" min-width="170">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" plain
                        @click="handleDetail(scope.$index, scope.row)">详情</el-button>
                    <el-button type="success" size="mini" :disabled="scope.row.status!=0" plain @click="handleEnter(scope.$index, scope.row)">完成</el-button>
                    <el-button type="danger" size="mini" plain :disabled="scope.row.status!=0" @click="handleFinish(scope.$index, scope.row)">关闭</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
            layout="total, prev, pager, next" :total="totalDataNumber" :page-size="filters.pageSize" align="center"
            class="fenye">
        </el-pagination>
        <el-dialog title="预约详情" class="twodialog" :visible.sync="dialogFormVisible">
            <el-form ref="form" :model="showForm">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="预约人" label-width="130px" prop="songPeople">
                      <el-input v-model.trim="showForm.user" readonly  class="commonwidth"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="社区名称" label-width="130px" prop="xzdate">
                        <el-input v-model.trim="showForm.community" readonly  class="commonwidth"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="服务对象" label-width="130px" prop="songPeople">
                      <el-input v-model.trim="showForm.name" readonly  class="commonwidth"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系方式" label-width="130px" prop="xzdate">
                        <el-input v-model.trim="showForm.mobile" readonly  class="commonwidth"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                      <el-form-item label="总金额" label-width="130px" prop="songPeople">
                        <el-input v-model.trim="showForm.price" readonly  class="commonwidth"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="评价" label-width="130px" prop="xzdate">
                          <el-input v-model.trim="showForm.evaluate" readonly  class="commonwidth"></el-input>
                      </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-table
                      :data="showFormList"
                      style="width: 100%">
                      <el-table-column
                        align="center"
                        label="照片">
                        <template slot-scope="scope">
                            <el-image style="width: 80px; height: 80px" :src="scope.row.pic">
                            </el-image>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="good"
                        align="center"
                        label="名称">
                      </el-table-column>
                      <el-table-column
                        prop="num"
                        align="center"
                        label="数量">
                      </el-table-column>
                    </el-table>
                </el-row>
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>
<script>
export default {
    name: "ServiceYuyue",
    data() {
        return {
            loading: true,
            filters: {
                user: null,
                status: null,
                pageNum: 1,
                groupId:sessionStorage.getItem("groupId"),
                pageSize: 5
            },
            showForm: {},
            showFormList:[],
            formLabelWidth:130,
            currentPage: 1,
            dialogFormVisible: false,
            totalDataNumber: 0,
            serviceList: [],
        };
    },
    methods: {
        handleDetail(index, row) {
           this.dialogFormVisible = true;
           this.showForm = row;
           this.showFormList = row.goodList;
        },
        handleEnter(index, row) {
          this.$confirm('确认服务已完成？')
          .then(_ => {
            var params = {
                id:row.id,
                status:1
            }
            this.$postJson("omc/WxApiPreService/updateStatus",params).then((res) => {
              if (res.code == 200) {
                console.log(res);
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.findList();
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            });
          }).catch(err=>{
            console.log('cancel')
          })
        },
        handleFinish(index, row) {
            this.$confirm('确认服务已关闭？')
            .then(_ => {
            var params = {
                id:row.id,
                status:2
            }
            this.$postJson("omc/WxApiPreService/updateStatus",params).then((res) => {
              if (res.code == 200) {
                console.log(res);
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.findList();
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            });
          }).catch(err=>{
            console.log('cancel')
          })
        },
        //修改table tr行的背景色
        tableRowStyle({ row, rowIndex }) {
            if (rowIndex % 2 == 0) {
                return "background-color: #ffffff";
            } else {
                return "background-color: #e4f5f8";
            }
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.filters.pageNum = val;
            this.findList(); //刷新套餐列表的数据
        },
        search() {
            this.filters.pageNum = 1;
            this.findList(); //刷新套餐列表的数据
        },
        findList() {
            //判断查询条件是否存在
            this.$postJson("omc/WxApiPreService/show", this.filters).then(res => {
                res.result.list.forEach(item => {
                    let goodStrList = item.goods.split("$");
                    let picList = [];
                    let goodList = [];
                    let title = "";
                    goodStrList.forEach(item2 => {
                        if (item2 != '') {
                            let item2SS = item2.split('@')
                            if(item2SS[2]!=null && item2SS[2].indexOf("cmny-test.oss-cn")>0){
                              goodList.push({
                                good:item2SS[0],
                                num:item2SS[1],
                                pic:item2SS[2]
                              })
                            }else{
                              goodList.push({
                                good:item2SS[0],
                                num:item2SS[1],
                                pic:"https://cmny-test.oss-cn-hangzhou.aliyuncs.com/" + item2SS[2]
                              })
                            }
                            
                            if (item2SS != null && item2SS.length > 2) {
                                if(item2SS[2]!=null && item2SS[2].indexOf("cmny-test.oss-cn")>0){
                                  picList.push(item2SS[2])
                                }else{
                                  picList.push("https://cmny-test.oss-cn-hangzhou.aliyuncs.com/" + item2SS[2])
                                }
                                title = title + item2SS[0] + ',';
                            } else if (item2SS != null && item2SS.length > 1) {
                                title = title + item2SS[0] + ',';
                            }
                        }
                    })
                    item.goodList = goodList;
                    item.pic = picList[0]
                    item.picList = picList;
                    if (item.status == 0) {
                        item.statusStr = '预约中';
                    } else if (item.status == 1) {
                        item.statusStr = '已完成';
                    } else {
                        item.statusStr = '已关闭';
                    }
                })
                this.serviceList = res.result.list;
                this.currentPage = res.result.pageNum;
                this.totalDataNumber = res.result.total * 1;
            });
        },
    },
    mounted() {
        this.findList();
    }
};
</script>
<style lang="scss" scoped>
  ::v-deep .twodialog .el-dialog {
    width: 800px !important;
  }
  .commonwidth{
    width: 260px;
  }
  .bigwidth{
    width: 640px;
  }
</style>